import cn from "classnames";

interface EmptyStateProps {
  hasActiveFilters?: boolean;
  noResultsText?: string;
  noDataText: string;
  noDataHint?: string;
  compact?: boolean;
}

export default function EmptyState({
  hasActiveFilters = false,
  noResultsText,
  noDataText,
  noDataHint,
  compact = false,
}: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-2", compact ? "py-8" : "py-16")}>
      <p className="text-body-bold-md content-base-primary">
        {hasActiveFilters && noResultsText ? noResultsText : noDataText}
      </p>
      {!hasActiveFilters && noDataHint && (
        <p className="text-body-regular-sm content-base-secondary">{noDataHint}</p>
      )}
    </div>
  );
}
